import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import './Screenshots.css';

const Screenshots = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  // Mock screenshot data - in real app, these would be actual screenshots
  const screenshots = [
    {
      id: 1,
      title: "Level Up System",
      description: "Earn XP points and unlock achievements as you complete routines",
      mockup: "dashboard"
    },
    {
      id: 2,
      title: "Routine Tracking",
      description: "Morning and evening skincare routines with step-by-step guidance",
      mockup: "routine"
    },
    {
      id: 3,
      title: "Streak Counter",
      description: "Build momentum with daily streaks and fire badges",
      mockup: "streaks"
    },
    {
      id: 4,
      title: "Achievement Badges",
      description: "Unlock special badges like 'Glow Getter' and 'Dew Master'",
      mockup: "achievements"
    }
  ];

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % screenshots.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + screenshots.length) % screenshots.length);
  };

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  return (
    <section id="screenshots" className="screenshots section">
      <div className="container">
        <motion.div
          initial={{ y: 50, opacity: 0 }}
          whileInView={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          <h2 className="section-title">See DailySkin in Action</h2>
          <p className="section-subtitle">
            Discover how DailySkin gamifies your skincare routine for better results
          </p>
        </motion.div>

        <div className="screenshots-container">
          <motion.button 
            className="nav-button nav-button-left"
            onClick={prevSlide}
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.9 }}
          >
            <FaChevronLeft />
          </motion.button>

          <div className="screenshots-carousel">
            <AnimatePresence mode="wait">
              <motion.div
                key={currentSlide}
                className="slide"
                initial={{ opacity: 0, x: 100 }}
                animate={{ opacity: 1, x: 0 }}
                exit={{ opacity: 0, x: -100 }}
                transition={{ duration: 0.5 }}
              >
                <div className="slide-content">
                  <div className="slide-info">
                    <motion.h3 
                      className="slide-title"
                      initial={{ y: 20, opacity: 0 }}
                      animate={{ y: 0, opacity: 1 }}
                      transition={{ delay: 0.2 }}
                    >
                      {screenshots[currentSlide].title}
                    </motion.h3>
                    <motion.p 
                      className="slide-description"
                      initial={{ y: 20, opacity: 0 }}
                      animate={{ y: 0, opacity: 1 }}
                      transition={{ delay: 0.3 }}
                    >
                      {screenshots[currentSlide].description}
                    </motion.p>
                  </div>
                  
                  <motion.div 
                    className="slide-mockup"
                    initial={{ scale: 0.8, opacity: 0 }}
                    animate={{ scale: 1, opacity: 1 }}
                    transition={{ delay: 0.1 }}
                  >
                    <div className="phone-mockup-carousel">
                      <div className="phone-frame-carousel">
                        <div className="phone-screen-carousel">
                          {screenshots[currentSlide].mockup === 'dashboard' && (
                            <img 
                              src="/screenshots/dashboard.png" 
                              alt="DailySkin Dashboard" 
                              className="real-screenshot"
                            />
                          )}
                          
                          {screenshots[currentSlide].mockup === 'routine' && (
                            <img 
                              src="/screenshots/routine.png" 
                              alt="DailySkin Routine Tracking" 
                              className="real-screenshot"
                            />
                          )}
                          
                          {screenshots[currentSlide].mockup === 'streaks' && (
                            <img 
                              src="/screenshots/streaks.png" 
                              alt="DailySkin Streak Counter" 
                              className="real-screenshot"
                            />
                          )}
                          
                          {screenshots[currentSlide].mockup === 'achievements' && (
                            <img 
                              src="/screenshots/achievements.png" 
                              alt="DailySkin Achievement Badges" 
                              className="real-screenshot"
                            />
                          )}
                        </div>
                      </div>
                    </div>
                  </motion.div>
                </div>
              </motion.div>
            </AnimatePresence>
          </div>

          <motion.button 
            className="nav-button nav-button-right"
            onClick={nextSlide}
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.9 }}
          >
            <FaChevronRight />
          </motion.button>
        </div>

        <div className="carousel-indicators">
          {screenshots.map((_, index) => (
            <motion.button
              key={index}
              className={`indicator ${index === currentSlide ? 'active' : ''}`}
              onClick={() => goToSlide(index)}
              whileHover={{ scale: 1.2 }}
              whileTap={{ scale: 0.9 }}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Screenshots;
